import styled from '@emotion/styled';
import { Grid, useMediaQuery } from '@mui/material';
import { GoogleMap, useJsApiLoader, Marker, Circle } from '@react-google-maps/api';
import { config } from '@/config/environment';

const Container = styled(Grid)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 22px;
  border: 0px solid #fff;
  width: 100%;
  overflow: hidden;
`;
interface LocationMapProps {
  lat: number;
  lng: number;
}

const LocationMap = ({ lat, lng }: LocationMapProps) => {
  const isMobile = useMediaQuery('(max-width:768px)');
  const containerStyle = {
    width: '100%',
    height: isMobile ? '300px' : '400px',
  };
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: config.googleApiKey!,
  });
  const circleOptions: google.maps.CircleOptions = {
    strokeColor: '#C699BB',
    strokeOpacity: 0.6,
    strokeWeight: 40,
    fillColor: '#C699BB',
    fillOpacity: 0.9,
    center: {
      lat,
      lng,
    },
    radius: 300,
    clickable: false,
    draggable: false,
    editable: false,
    visible: true,
    zIndex: 10,
  };
  return (
    <Container>
      {isLoaded && (
        <GoogleMap mapContainerStyle={containerStyle} center={{ lat, lng }} zoom={14}>
          <Marker position={{ lat, lng }} visible={false} />
          <Circle options={circleOptions} />
        </GoogleMap>
      )}
    </Container>
  );
};

export default LocationMap;
